import Link from "next/link";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-bg">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-6 py-8 sm:flex-row">
        <div className="flex items-center gap-0.5">
          <span className="font-display text-sm font-bold text-white">Clear</span>
          <span className="font-display text-sm font-bold text-accent">Cut</span>
        </div>

        <div className="flex items-center gap-6 text-xs text-muted">
          <Link href="/terms" className="transition-colors hover:text-white">
            Terms of Service
          </Link>
          <Link href="/privacy" className="transition-colors hover:text-white">
            Privacy Policy
          </Link>
          <Link href="/pricing" className="transition-colors hover:text-white">
            Pricing
          </Link>
        </div>

        <p className="text-xs text-muted-dim">
          &copy; {new Date().getFullYear()} ClearCut
        </p>
      </div>
    </footer>
  );
}
